import NextLink from "next/link";
import type { ReactNode } from "react";

type ResultRowProps = {
  href?: string;
  title: ReactNode;
  meta?: ReactNode;
  description?: ReactNode;
  trailing?: ReactNode;
};

export function ResultRow({
  href,
  title,
  meta,
  description,
  trailing,
}: ResultRowProps) {
  const inner = (
    <>
      <span className="result-row-body">
        <span className="result-row-title">{title}</span>
        {meta ? <span className="result-row-meta">{meta}</span> : null}
        {description ? (
          <span className="result-row-description">{description}</span>
        ) : null}
      </span>
      {trailing ? <span className="result-row-trailing">{trailing}</span> : null}
    </>
  );

  if (href) {
    return (
      <NextLink href={href} className="result-row">
        {inner}
      </NextLink>
    );
  }

  return <div className="result-row">{inner}</div>;
}
